module.exports = __webpack_public_path__ + "media/images/emp/nist_logo_w-37088ea8dada34ee11efbb7be330e79e.png";